<template>
  <b-card no-body>
    <h6 slot="header" class="mb-0">
      <font-awesome-icon icon="cog" />เป้าหมาย/ตัวชี้วัดความสำเร็จ
    </h6>

    <table class="table table-striped table-bordered table-sm m-0">
      <thead>
        <tr>
          <th class="text-center align-middle" rowspan="2" width="50">ที่</th>
          <th class="text-center align-middle" rowspan="2">กิจกรรม</th>
          <th class="text-center" colspan="2">งบประมาณ</th>
          <th class="text-center" colspan="2">เป้าหมาย</th>
        </tr>
        <tr>
          <th class="text-center" width="100">แผน</th>
          <th class="text-center" width="100">ผล</th>
          <th class="text-center" width="100">แผน</th>
          <th class="text-center" width="100">ผล</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(outcome, index) in value" :key="index">
          <td class="align-middle text-center">{{ index + 1 }}</td>
          <td class="align-middle">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span style="white-space: pre" v-html="newlineFormatter(outcome.title)" />
            <span v-if="index > 0"> {{ outcome.goal.planned }}</span>
          </td>
          <td class="align-middle text-center">
            <template v-if="index === 0">{{ outcome.spending.planned | numeral('0,0.00') }}</template>
            <template v-else>{{ outcome.spending.planned || '-' }}</template>
          </td>
          <td class="align-middle text-center">{{ outcome.spending.actual || '-' }}</td>
          <td class="align-middle text-center">
            <span v-if="index > 0">{{ outcome.goal.planned }}%</span>
            <span v-else>-</span>
          </td>
          <td class="align-middle text-center">-</td>
        </tr>
      </tbody>
    </table>
  </b-card>
</template>

<script>
export default {
  props: {
    value: { type: Array, required: true }
  },
  methods: {
    newlineFormatter (str) {
      return str.replace('\\n', '<br>')
    }
  }
}
</script>

<style scoped lang="scss">

</style>
